import { cmsApiClient } from '@/config/httpClients';
import type { GlobalKey, GlobalTypes } from './schemas';
import { GlobalSchemas } from './schemas';

export const getGlobals = async <K extends GlobalKey>(
  key: K
): Promise<GlobalTypes[K]> => {
  const response = await cmsApiClient
    .get<{ data: GlobalTypes[K] }>(`globals/${key}`)
    .json();

  if (!GlobalSchemas[key].safeParse(response.data).success) {
    // TODO: log to Sentry
    console.log(GlobalSchemas[key].safeParse(response.data).error);
  }

  return response.data;
};
